module.exports = __webpack_public_path__ + "static/img/irole.fd5fb85.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/tysdags/irole.png
// module id = tjo3
// module chunks = 7